module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xCMJiZ/tc-custom/9781459220522.jpg?1725275783991",
      "alt": "This image is the cover for the book Lone Wolfe, The Notorious Wolfes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lone Wolfe, The Notorious Wolfes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After years lying neglected, the walls of Wolfe Manor tremble as Jacob Wolfe returnsthe master is back!"), _c('br'), _c('br'), _vm._v("Gardener's daughter Mollie Parker has lived amidst the secret, overgrown garden in her little cottagewaitingfor what, she wasn't sureuntil now."), _c('br'), _c('br'), _vm._v("Reputation in tatters, Jacob licks his wounds alone in the shadows. Mollie knows his ferocious bark is worse than his bite and as she takes her tentative steps across the threshold, she brings with her the light missing from his darkened soul. The lone Wolfe will never be tamedbut she knows that once he loves, he loves for life."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Hewitt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to church youth worker, but writing romance is the best one yet. She also writes short stories and serials for women's magazines, and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village with her husband, five children, and an overly affectionate Golden Retriever.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0